<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <!-- <span v-else class="sidebar-content">
          <div class="sidebar-content-title">{{ title }}</div>
          <div class="sidebar-content-sub-title">活动管理商户端</div>
        </span> -->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <span class="sidebar-content">
          <div class="sidebar-content-title">{{ title }}</div>
          <!-- <div class="sidebar-content-sub-title">活动管理商户端</div> -->
        </span>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { getOSSFullUrl } from '@/libs/utils'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    title () {
      return this.$store.state.MerchantMe.merchantInfo && this.$store.state.MerchantMe.merchantInfo.shortName
    },
    logo () {
      const m = this.$store.state.MerchantMe.merchantInfo
      const raw = m && m.merchantHomePage && m.merchantHomePage.brandIconUrl
      if (!raw) return ''
      return getOSSFullUrl(raw)
    },
    merchantInfo () {
      return this.$store.state.MerchantMe.merchantInfo
    }
  },
  watch: {
    // 监听 merchantInfo 变化，确保标题及时更新
    merchantInfo: {
      handler(newVal, oldVal) {
        // 当 merchantInfo 变化时，强制更新组件
        if (newVal && (!oldVal || (oldVal && newVal.merchantId !== oldVal.merchantId))) {
          this.$forceUpdate()
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    // 组件挂载时，如果 merchantInfo 为空，主动获取
    if (!this.$store.state.MerchantMe.merchantInfo) {
      await this.$store.dispatch('MerchantMe/getMerchantInfo')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 106px;
  line-height: 106px;
  // background: #2b2f3a;
  text-align: left;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 40px;
      height: 40px;
      padding: 6px;
      background-color: #fff;
      border-radius: 5px;
      vertical-align: middle;
      margin-right: 20px;
      margin-left: 20px;
    }

    & .sidebar-content {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      font-family: PingFangSC-Semibold, sans-serif;
      vertical-align: middle;
      
      & .sidebar-content-title {
        line-height: 30px;
        // margin-bottom: -10px;
      }

      & .sidebar-content-sub-title {
        line-height: 30px;
      }
    }
  }

  &.collapse {
    text-align: center;
    .sidebar-logo {
      margin-left: 0;
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue